var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { lastValueFrom } from "rxjs";
import { getEnvAccessToken, getSession } from "../utils/auth0";
import { getServerRuntimeConfig } from "../utils/runtime-config";
export const handleAccountData = (req, res) => __awaiter(void 0, void 0, void 0, function* () {
    res.setHeader("Cache-Control", "no-store");
    const { accountId } = req.query;
    if (typeof accountId !== "string" || accountId === "") {
        res.status(400).json({ message: "Account ID is required" });
        return;
    }
    const user = yield getSession(req, res).then((session) => session);
    if (!(user === null || user === void 0 ? void 0 : user.user)) {
        res.status(401).json({ message: "Not authenticated" });
        return;
    }
    const accessTokenObservable = getEnvAccessToken();
    const { access_token } = yield lastValueFrom(accessTokenObservable);
    const { DTN_IDENTITY_HOST } = getServerRuntimeConfig();
    const identityHost = DTN_IDENTITY_HOST !== null && DTN_IDENTITY_HOST !== void 0 ? DTN_IDENTITY_HOST : "https://identity.auth.dtn.com";
    const accountUrl = `${identityHost}/v2/accounts/${encodeURIComponent(accountId)}?env=dev&env=lod&env=stg&env=prd`;
    const response = yield fetch(accountUrl, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "content-type": "application/json",
            Authorization: `Bearer ${access_token}`,
        },
    });
    if (!response.ok) {
        const errorText = yield response.text();
        // eslint-disable-next-line no-console
        console.error("Identity service error:", {
            status: response.status,
            statusText: response.statusText,
            body: errorText,
            url: accountUrl,
        });
        res.status(response.status).json({
            message: `Failed to fetch account data from identity service: ${response.statusText}`,
            error: errorText,
        });
        return;
    }
    const responseData = (yield response.json());
    res.status(200).json({ data: responseData.data });
});
